import React from "react";
import ControlsHeader from "shared/ControlsHeader";
import Button from "shared/Button";
import styles from "./Radio.module.css";

export const Radio = () => {
  const handleLogin = () => {
    window.open("https://radio.wwdb.live/login", "_blank");
  };
  

  return (
    <div className={styles.page}>
      <ControlsHeader title="DreamCast - Radio" />
      
      <div className={styles.contentSection}>
        <div className={styles.sectionContainer}>
          <svg
            className={styles.radioIcon}
            xmlns="http://www.w3.org/2000/svg"
            width="75"
            height="75"
            viewBox="0 0 75 75"
            fill="none"
          >
            <path
              d="M65 0H10C4.47715 0 0 4.47715 0 10V65C0 70.5229 4.47715 75 10 75H65C70.5229 75 75 70.5229 75 65V10C75 4.47715 70.5229 0 65 0Z"
              fill="#91B6BB"
            />
            <path
              d="M21.06 54.8924C20.79 54.8924 20.525 54.7927 20.32 54.5881C15.6 49.8781 13 43.6114 13 36.9456C13 30.2798 15.6 24.0181 20.325 19.3081C20.73 18.904 21.39 18.904 21.8 19.3081C22.205 19.7122 22.205 20.3708 21.8 20.78C17.465 25.1008 15.08 30.8386 15.08 36.9506C15.08 43.0626 17.465 48.8004 21.795 53.1212C22.2 53.5253 22.2 54.1889 21.795 54.5931C21.59 54.7976 21.32 54.8974 21.055 54.8974L21.06 54.8924Z"
              fill="white"
            />
            <path
              d="M54.94 54.8924C54.675 54.8924 54.405 54.7927 54.2 54.5881C53.8 54.1839 53.8 53.5254 54.2 53.1162C58.53 48.7954 60.915 43.0526 60.915 36.9456C60.915 30.8386 58.53 25.0958 54.2 20.775C53.8 20.3708 53.8 19.7122 54.2 19.3031C54.605 18.899 55.27 18.899 55.675 19.3031C60.4 24.0181 63 30.2798 63 36.9406C63 43.6014 60.4 49.8731 55.675 54.5781C55.48 54.7827 55.21 54.8825 54.94 54.8825V54.8924Z"
              fill="white"
            />
            <path
              d="M25.48 50.4818C25.21 50.4818 24.945 50.382 24.74 50.1775C21.195 46.65 19.24 41.95 19.24 36.9506C19.24 31.9512 21.195 27.2512 24.74 23.7237C25.145 23.3246 25.805 23.3196 26.21 23.7237C26.615 24.1278 26.615 24.7864 26.21 25.1956C23.065 28.3289 21.335 32.505 21.335 36.9506C21.335 41.3961 23.065 45.5723 26.22 48.7056C26.625 49.1097 26.625 49.7733 26.22 50.1775C26.015 50.382 25.75 50.4868 25.48 50.4868V50.4818Z"
              fill="white"
            />
            <path
              d="M50.52 50.4818C50.25 50.4818 49.985 50.382 49.78 50.1775C49.375 49.7733 49.375 49.1097 49.78 48.7056C52.93 45.5673 54.665 41.3911 54.665 36.9456C54.665 32.5 52.935 28.3289 49.78 25.1906C49.375 24.7864 49.375 24.1278 49.78 23.7187C50.185 23.3096 50.845 23.3146 51.255 23.7187C54.795 27.2512 56.75 31.9512 56.75 36.9456C56.75 41.94 54.795 46.645 51.255 50.1725C51.055 50.3721 50.79 50.4768 50.52 50.4768V50.4818Z"
              fill="white"
            />
            <path
              d="M29.9 46.0762C29.63 46.0762 29.365 45.9764 29.16 45.7718C26.8 43.4118 25.5 40.2835 25.5 36.9506C25.5 33.6177 26.8 30.4843 29.16 28.1293C29.565 27.7252 30.225 27.7252 30.635 28.1293C31.045 28.5335 31.04 29.1921 30.635 29.6012C28.67 31.567 27.58 34.1715 27.58 36.9506C27.58 39.7297 28.665 42.3391 30.635 44.3C31.04 44.7041 31.04 45.3677 30.635 45.7718C30.43 45.9714 30.16 46.0762 29.895 46.0762H29.9Z"
              fill="white"
            />
            <path
              d="M46.1 46.0762C45.835 46.0762 45.565 45.9764 45.36 45.7718C44.955 45.3677 44.955 44.7091 45.36 44.3C47.325 42.3391 48.415 39.7247 48.415 36.9506C48.415 34.1765 47.33 31.562 45.36 29.6012C44.955 29.1971 44.955 28.5385 45.36 28.1293C45.765 27.7202 46.425 27.7252 46.835 28.1293C49.195 30.4793 50.495 33.6177 50.495 36.9506C50.495 40.2835 49.19 43.4168 46.835 45.7718C46.635 45.9714 46.37 46.0762 46.1 46.0762Z"
              fill="white"
            />
            <path
              d="M38 41.0968C40.2947 41.0968 42.155 39.2405 42.155 36.9506C42.155 34.6607 40.2947 32.8044 38 32.8044C35.7052 32.8044 33.845 34.6607 33.845 36.9506C33.845 39.2405 35.7052 41.0968 38 41.0968Z"
              fill="white"
            />
          </svg>

          <div className={styles.textContainer}>
            <h2 className={styles.title}>WWG Radio Admin</h2>
            <p className={styles.subtitle}>
              Create, Edit, & Upload Radio Content for DreamCast™
            </p>
          </div>

          <Button className={styles.loginButton} onClick={handleLogin} purpose="primary">
            Login Here
          </Button>
        </div>
      </div>
    </div>
  );
};
